export {HeaderDataInterface} from './interfaces/header-data.interface';

export {HeaderComponent} from './header.component';
export {HeaderBoxComponent} from './components/header-box/header-box.component';
